<template>
  <Nuxt id="main" />
</template>

<script>
export default {
  name: 'LayoutHome',
}
</script>
